const RELOAD_TIMESTAMP_KEY: string = 'enlivio.modulePreloadReloadedAt';
const RELOAD_COOLDOWN_MILLIS: number = 30_000;

function wasReloadedRecently(): boolean {
  const storedTimestamp: string | null = sessionStorage.getItem(RELOAD_TIMESTAMP_KEY);
  if (!storedTimestamp) {
    return false;
  }

  const reloadedAt: number = Number(storedTimestamp);
  if (!Number.isFinite(reloadedAt)) {
    return false;
  }

  return Date.now() - reloadedAt < RELOAD_COOLDOWN_MILLIS;
}

export function registerModulePreloadRecovery(): void {
  window.addEventListener('vite:preloadError', (event: Event) => {
    if (wasReloadedRecently()) {
      return;
    }

    event.preventDefault();
    sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, Date.now().toString());
    window.location.reload();
  });
}
